// extracted by mini-css-extract-plugin
export var hasMostPopular = "pricing_table-module--hasMostPopular--8ad21";
export var icon = "pricing_table-module--icon--b86ec";
export var mostPopular = "pricing_table-module--mostPopular--97215";
export var period = "pricing_table-module--period--1dfcb";
export var plan = "pricing_table-module--plan--6801e";
export var point = "pricing_table-module--point--7f0a0";
export var price = "pricing_table-module--price--576b8";
export var subTitle = "pricing_table-module--subTitle--faf7c";
export var title = "pricing_table-module--title--dead6";